import React from 'react';
import ChatSidePanelCard from '../sidepanel/ChatSidePanelCard';
import ChatSidePanelSection from '../sidepanel/ChatSidePanelSection';
import ChatSidePanelGroupedPeopleList from './ChatSidePanelGroupedPeopleList';
import ChatSidePanelPeopleList from './ChatSidePanelPeopleList';

export default function GroupChatParticipantsPanel({
  assignees = [],
  groupedArtists = [],
  onSelectAssignee,
  onSelectArtist,
  resolveAssigneeKey,
  resolveArtistKey,
  renderAssigneeName,
  renderAssigneeMeta,
  renderArtistName,
  resolveAssigneeAvatarStyle,
  resolveAssigneeAvatarFallback,
  resolveArtistAvatarStyle,
  resolveArtistAvatarFallback,
  assigneeTitle = '担当管理者',
  assigneeEmptyText = '担当者は設定されていません。',
  artistTitle = '参加アーティスト',
  artistEmptyText = '参加アーティストがいません。',
  unassignedPartLabel = '未設定',
  assigneeCardClassName = 'side-panel-card',
  artistCardClassName = 'side-panel-card',
  assigneeRowClassName = 'side-panel-profile side-panel-profile--clickable',
  artistRowClassName = 'side-panel-profile side-panel-profile--clickable',
  assigneeAvatarClassName = 'side-avatar',
  artistAvatarClassName = 'side-avatar',
  assigneeNameClassName = 'side-name',
  artistNameClassName = 'side-name',
  assigneeMetaClassName = 'side-meta',
  assigneeNameStyle = undefined,
  artistNameStyle = undefined,
}) {
  const safeAssignees = Array.isArray(assignees) ? assignees : [];
  const safeGroups = Array.isArray(groupedArtists) ? groupedArtists : [];
  const normalizeCardClassName = (value) =>
    String(value || '')
      .replace(/\bside-panel-card\b/g, '')
      .replace(/\s+/g, ' ')
      .trim();

  return (
    <>
      <ChatSidePanelCard title={assigneeTitle} className={normalizeCardClassName(assigneeCardClassName)}>
        <ChatSidePanelSection
          isEmpty={safeAssignees.length === 0}
          emptyText={assigneeEmptyText}
          title=""
          className=""
        >
          <ChatSidePanelPeopleList
            people={safeAssignees}
            onSelect={onSelectAssignee}
            resolveRowKey={(assignee, index) => resolveAssigneeKey?.(assignee, index) ?? `assignee-${index}`}
            resolveRowProps={(assignee) => {
              const name = renderAssigneeName?.(assignee) || '管理者';
              const meta = renderAssigneeMeta?.(assignee) || '';
              return {
                adminUserId: assignee?.admin_user_id ?? assignee?.adminUserId ?? assignee?.id,
                rowClassName: assigneeRowClassName,
                avatarClassName: assigneeAvatarClassName,
                nameClassName: assigneeNameClassName,
                metaClassName: assigneeMetaClassName,
                name,
                meta,
                nameStyle: assigneeNameStyle,
                avatarStyle: resolveAssigneeAvatarStyle?.(assignee),
                avatarFallback: resolveAssigneeAvatarFallback?.(assignee) || '',
                showMeta: Boolean(meta),
                fallbackName: '管理者',
              };
            }}
            listClassName="side-list"
          />
        </ChatSidePanelSection>
      </ChatSidePanelCard>

      <ChatSidePanelCard title={artistTitle} className={normalizeCardClassName(artistCardClassName)}>
        <ChatSidePanelSection
          isEmpty={safeGroups.length === 0}
          emptyText={artistEmptyText}
          title=""
          className=""
        >
          <ChatSidePanelGroupedPeopleList
            groups={safeGroups}
            unassignedLabel={unassignedPartLabel}
            resolveGroupKey={(group, groupIndex) => String(group?.key || group?.id || `group-${groupIndex}`)}
            resolveGroupLabel={(group) => String(group?.label || group?.title || unassignedPartLabel)}
            onSelect={onSelectArtist}
            resolveRowKey={(artist, artistIndex, group) =>
              resolveArtistKey?.(artist, artistIndex, group) ||
              `artist-${String(group?.key || group?.id || 'group')}-${artistIndex}`
            }
            resolveRowProps={(artist) => ({
              rowClassName: artistRowClassName,
              avatarClassName: artistAvatarClassName,
              nameClassName: artistNameClassName,
              name: renderArtistName?.(artist) || 'アーティスト',
              nameStyle: artistNameStyle,
              avatarStyle: resolveArtistAvatarStyle?.(artist),
              avatarFallback: resolveArtistAvatarFallback?.(artist) || '',
              fallbackName: 'アーティスト',
            })}
          />
        </ChatSidePanelSection>
      </ChatSidePanelCard>
    </>
  );
}
